/**
 * AppFooter — the discreet, always-visible bottom bar of every app shell.
 *
 * Hosts the deployed-version `VersionChip` (right) and a muted brand/copyright
 * line (left). Mounted at the bottom of the authenticated-user shell, the
 * super-admin and org-admin layouts, and the public landing footer, so the
 * version indicator lives here instead of the navbar/header.
 *
 * The chip's detail popover opens UPWARD (its default `placement="top"`) so it
 * is never clipped at the bottom edge of the viewport.
 */

import React from 'react'

import { VersionChip } from '@/shared/version/VersionChip'

export const AppFooter: React.FC = React.memo(function AppFooter() {
  const currentYear = new Date().getFullYear()

  return (
    <footer
      role="contentinfo"
      data-testid="app-footer"
      className="glass-effect border-t border-crypto-border/50 px-6 py-2"
    >
      <div className="flex items-center justify-between gap-4">
        {/* Brand + year — language-neutral, so it needs no i18n key. */}
        <span className="text-xs text-crypto-muted">© {currentYear} Block&amp;Taxes</span>

        {/* Deployed version indicator — popover opens upward from the footer. */}
        <VersionChip />
      </div>
    </footer>
  )
})

AppFooter.displayName = 'AppFooter'
